import styles from './index.module.scss'
import buildingImg from '../../../assets/images/buildingDefault.png'
import { IBuilding } from '../../../models'
import { useTranslation } from 'react-i18next'
interface ICardBuildingProps {
  building: IBuilding
}

export const CardBuilding = ({ building }: ICardBuildingProps) => {
  const {t} = useTranslation()
  return (
    <div className={styles.item}>
      <img className={styles.item__img} src={buildingImg} alt="" />
      <div className={styles.item__wrap}>
        <div className={styles.item__left}>
          <div className={styles.item__title}>
            <span className={styles.item__title__text}>{building.name}</span>
            {building.name_katakana && <span className={styles.item__sub__title}>{`(${building.name_katakana})`}</span>}
          </div>
          <hr className={styles.hr} />
          <div className={styles.wrap__iteminfo}>
            <div className={styles.item__info}>
              <span>{t('building.building_code')}: </span>
              <span>{building.management_association_no}</span>
            </div>
            <div className={styles.item__info}>
              <span>{t('building.managerment_association_name')}: </span>
              {building.management_association_name && <span>{building.management_association_name}</span>}
            </div>
            <div className={styles.item__info}>
              <span>{t('building.postal_code')}: </span>
              {building.postal_code && <span>{building.postal_code}</span>}
            </div>
            <div className={styles.item__info}>
              <span>{t('building.address_1')}: </span>
              {building.address_1 && <span>{building.address_1}</span>}
            </div>
            <div className={styles.item__info}>
              <span>{t('building.address_2')}: </span>
              {building.address_2 && <span>{building.address_2}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
